import axios from 'axios'
import { stringify } from 'query-string'

export const getFinanceStockAdjustment = (id, includeStockBefore = 0, params = {}) => {
  const currentParams = params
  if (includeStockBefore === 1) currentParams.include_stock_before = 1

  const query = stringify(currentParams)
  return axios.get(`/finance/stockAdjustments/${id}?${query}`)
}

export const getFinanceStockAdjustmentLog = (id, params) => {
  const query = stringify(params)
  return axios.get(`/finance/stockAdjustments/${id}/logs?${query}`)
}

export const getFinanceStockAdjustments = (params) => {
  const query = stringify(params)
  return axios.get(`/finance/stockAdjustments?${query}`)
}

export const addFinanceStockAdjustment = (data) => {
  return axios.post('/finance/stockAdjustments', data)
}

export const editFinanceStockAdjustment = (data) => {
  return axios.put(`/finance/stockAdjustments/${data.id}`, data)
}

export const deleteFinanceStockAdjustment = (id) => {
  return axios.delete(`/finance/stockAdjustments/${id}`)
}

export const deleteOnAddFinanceStockAdjustmentAttachment = (url) => {
  return axios.delete('/finance/stockAdjustments/attachments', { data: { url } })
}

export const deleteOnEditFinanceStockAdjustmentAttachment = (id, url) => {
  return axios.delete(`/finance/stockAdjustments/${id}/attachments`, { data: { url } })
}

export const generateImportFinanceStockAdjustment = (params) => {
  const query = stringify(params)
  return axios.get(`/finance/stockAdjustments/generateImport?${query}`, {
    responseType: 'arraybuffer',
  })
}

export const uploadImportFinanceStockAdjustment = (data) => {
  return axios.postForm('/finance/stockAdjustments/uploadImport', data)
}

export const executeImportFinanceStockAdjustment = (data) => {
  return axios.post('/finance/stockAdjustments/executeImport', data)
}

export const approveFinanceStockAdjustment = ({ id }) => {
  return axios.post(`/finance/stockAdjustments/${id}/approve`)
}

export const rejectFinanceStockAdjustment = ({ id, body }) => {
  return axios.post(`/finance/stockAdjustments/${id}/reject`, body)
}

export const revertApprovalFinanceStockAdjustment = ({ id }) => {
  return axios.post(`/finance/stockAdjustments/${id}/revert`)
}
